/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1ExamRevisionQuestionMutationRequest,
  PutApiV1ExamRevisionQuestionMutationResponse,
  PutApiV1ExamRevisionQuestion400,
  PutApiV1ExamRevisionQuestion401,
  PutApiV1ExamRevisionQuestion404,
  PutApiV1ExamRevisionQuestion500,
} from "../../types/examRevisionController/PutApiV1ExamRevisionQuestion.ts";

function getPutApiV1ExamRevisionQuestionUrl() {
  const res = { method: "PUT", url: `/api/v1/exam/revision/question` as const };
  return res;
}

/**
 * @description Cria ou atualiza uma questão de tradução com suas opções. Quando QuestionId for 0, cria uma nova questão vinculada ao idioma informado; caso contrário, atualiza a questão existente. Após salvar, recalcula automaticamente o status do idioma e da prova com base na situação de revisão das questões. **(Requer Authorization para autenticação)**
 * @summary Salvar questão de tradução da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/question}
 */
export async function putApiV1ExamRevisionQuestion(
  data?: PutApiV1ExamRevisionQuestionMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1ExamRevisionQuestionMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1ExamRevisionQuestionMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionQuestion400
      | PutApiV1ExamRevisionQuestion401
      | PutApiV1ExamRevisionQuestion404
      | PutApiV1ExamRevisionQuestion500
    >,
    PutApiV1ExamRevisionQuestionMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1ExamRevisionQuestionUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
